
import { accessibeDomService } from '@/services/accessibe-dom.service';
import { Attributes, PageAttributeType } from '@/entities/page.attributes';
import { configService } from '@/services/config.service';
import pageAttributesService from '@/services/page.attributes.service';

class AccessibilityService {
  public async showAccessibityWidget(): Promise<void> {
    const envConfig = await configService.getConfigs();
    const isEnabledInEnvironment = envConfig.showAccessibilityWidget === 1;

    const plConfig: Attributes = await pageAttributesService.getPageAttributeByTypeId(PageAttributeType.PAGE_ELEMENT_SECTION_CONFIG_TYPE);
    // eslint-disable-next-line
    const isEnabledInProgram = plConfig.attributes['SHOW_ACCESSIBILITY_WIDGET_FOR_ALL_PAGES'] === '1';

    if (isEnabledInEnvironment && isEnabledInProgram) {
      accessibeDomService.addWidgetScript();
    }
  }
}
export const accessibilityService = new AccessibilityService();
